import { render, staticRenderFns } from "./dataPackagesixth.vue?vue&type=template&id=2f152522&scoped=true"
import script from "./dataPackagesixth.vue?vue&type=script&lang=js"
export * from "./dataPackagesixth.vue?vue&type=script&lang=js"
import style0 from "./dataPackagesixth.vue?vue&type=style&index=0&id=2f152522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f152522",
  null
  
)

export default component.exports